import { ImageLink } from "../../../../../utils/constants";
const ProductCard = ({ item, editable = false, itemsQuantity, setItemsQuantity }) => {
  const content = JSON.parse(item?.productsnapshots);
  const maxQty = item.remainingQty;

  return (
    <div className="card mb-2 shadow-sm border-0 rounded-3" style={{ minHeight: "100px" }}>
      <div className="card-body d-flex align-items-center p-2">
        <img
          src={ImageLink(content?.image)}
          alt={content.name}
          className="me-3"
          style={{
            width: "80px",
            height: "100px",
            objectFit: "cover",
            borderRadius: "6px",
            flexShrink: 0,
          }}
        />
        <div className="flex-grow-1 me-2 ml-2">
          <p className="mb-1 fw-semibold" style={{ fontSize: "0.95rem" }}>
            {content.name}
          </p>
          <div className="d-flex flex-column gap-1" style={{ fontSize: "0.90rem" }}>
            <span className="text-muted">Ordered: {item.quantity}</span>
            {item.quantity - item.remainingQty > 0 && (
              <span className="text-success">Dispatched: {item.quantity - item.remainingQty}</span>
            )}
            {item.remainingQty > 0 && (
              <span className="text-danger">Pending: {item.remainingQty}</span>
            )}
          </div>
        </div>

        {editable && (
          <div className="d-flex align-items-center" style={{ minWidth: "90px" }}>
            <input
              type="number"
              className="form-control form-control-sm me-1"
              style={{ width: "60px", height: "32px", fontSize: "0.85rem", padding: "2px 6px" }}
              value={itemsQuantity[item.id] ?? maxQty}
              min={0}
              max={maxQty}
              onChange={(e) => {
                const value = e.target.value;
                if (value === "") {
                  setItemsQuantity((prev) => ({ ...prev, [item.id]: "" }));
                  return;
                }
                let numberValue = parseInt(value, 10);
                if (isNaN(numberValue) || numberValue < 0) numberValue = 0;
                if (numberValue > maxQty) numberValue = maxQty;
                setItemsQuantity((prev) => ({ ...prev, [item.id]: numberValue }));
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductCard;
